import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        accessToken: null,
        artists: null,
        popular_artists: null,
        playing: null
    },
    mutations: {
        login(state, accessToken) {
            state.accessToken = accessToken;
            sessionStorage.setItem("accessToken", accessToken);
        },
        popular_artists(state, popular_artists) {
            state.popular_artists = popular_artists;
            sessionStorage.setItem("popular_artists", popular_artists);
        },
        artists(state, artists) {
            state.artists = artists;
            sessionStorage.setItem("artists", artists);
        },
        initialiseStore(state) {
            state.accessToken = sessionStorage.getItem("accessToken");
        },
        play(state, uri) {
            state.playing = uri;
        }
    },
    getters: {
        loggedIn(state) {
            return state.accessToken != null;
        }
    }
});
